import { useEffect, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';

export const useApi = () => {
  const { getAccessTokenSilently, isAuthenticated, isLoading } = useAuth0();
  const [state, setState] = useState({
    token: ""
  });
  const [refreshIndex, setRefreshIndex] = useState(0);

  useEffect(() => {
    // Auth0Provider resolves the redirect callback / session in its own effect, which runs
    // after the effects of its children. Waiting for it keeps us from making a single failed
    // token request against an empty cache and latching an empty token for the whole session.
    if (isLoading || !isAuthenticated) {
      return;
    }
    (async () => {
      try {
        const accessToken = await getAccessTokenSilently();
        setState({
          token: accessToken
        });
      } catch (error) {
        console.log(`UseApi error: ${error}`);
        setState({
          token: ""
        });
      }
    })();
  }, [refreshIndex, getAccessTokenSilently, isAuthenticated, isLoading]);

  return {
    ...state,
    refresh: () => setRefreshIndex(refreshIndex + 1),
  };
};
